import { CommonModule } from '@angular/common';
import {
  Component,
  DestroyRef,
  inject,
  Renderer2,
  signal,
} from '@angular/core';
import { tap } from 'rxjs';

import { LoadingService } from './ui-loading.service';

@Component({
  selector: 'esp-loading',
  imports: [CommonModule],
  templateUrl: './ui-loading.component.html',
  styleUrl: './ui-loading.component.scss',
})
export class LoadingComponent {
  private readonly loadingService = inject(LoadingService);
  private renderer = inject(Renderer2);
  private destroyRef = inject(DestroyRef);
  private keyListener: (() => void) | null = null;

  allowedKeyCodes = ['F5'];

  isLoading$ = this.loadingService.isLoading$.pipe(
    tap((isLoading) => {
      this.blockKeys.set(isLoading);
      this.enableKeyLock(isLoading);
    }),
  );

  blockKeys = signal(false);

  constructor() {
    this.destroyRef.onDestroy(() => {
      this.unblockKeys();
    });
  }

  enableKeyLock(shouldBlockKeys: boolean) {
    if (!shouldBlockKeys || this.keyListener !== null) {
      this.unblockKeys();
      return;
    }

    this.keyListener = this.renderer.listen(
      'window',
      'keydown',
      (event: KeyboardEvent) => {
        if (!this.allowedKeyCodes.includes(event.key)) {
          event.preventDefault();
        }
      },
    );
  }

  unblockKeys() {
    this.keyListener?.();
    this.keyListener = null;
  }
}
